export const environment = {
    production: true,
    hmr: false,

    // -----------------------------------------
    //      @ BACKEND
    // -----------------------------------------
    backEnd: 'https://testing-api.medicareweb.in',

    // -----------------------------------------
    //      @ APP SECURITY
    // -----------------------------------------
    issuer: 'https://testing-auth.medicareweb.in',
    clientId: 'medcilia-admin',
    scope: 'openid profile administration',
    redirectUri: 'https://testing-ams.medicareweb.in/',
    silentRefreshRedirectUri: 'https://testing-ams.medicareweb.in/silent-refresh.html',
    postLogoutRedirectUri: 'https://testing-ams.medicareweb.in/',

    // -----------------------------------------
    //      @ GRAPGQL
    // -----------------------------------------
    GQL_SCHEMA_VERSION: '0.2'
};
